import { useState } from 'react';
import type { TransicaoDisponivel } from '../../api/tipos.js';
import { labelEvento } from '../../api/tipos.js';

interface ModalTransicaoProps {
  transicao: TransicaoDisponivel;
  consequencias?: string;
  exigeOverride?: boolean;
  onConfirmar: (justificativa?: string, aprovadorSuperior?: string) => void;
  onFechar: () => void;
  carregando?: boolean;
}

// SPEC-UX §3.2 — toda transição abre o mesmo modal: ação em verbo,
// consequências, campo de justificativa quando a regra exige. Modal de
// override (I2, I8) exige adicionalmente o aprovador de nível superior.
// Sem "Tem certeza?" genérico (§8 anti-padrão 5) — sempre mostra o que
// vai acontecer.
export function ModalTransicao({ transicao, consequencias, exigeOverride, onConfirmar, onFechar, carregando }: ModalTransicaoProps) {
  const [justificativa, setJustificativa] = useState('');
  const [aprovadorSuperior, setAprovadorSuperior] = useState('');

  const podeConfirmar = (!transicao.exigeJustificativa || justificativa.trim().length > 0) && (!exigeOverride || aprovadorSuperior.trim().length > 0);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-ink/40 p-4" role="dialog" aria-modal="true" aria-labelledby="modal-transicao-titulo">
      <div className="w-full max-w-md rounded-lg border border-borda bg-superficie p-5 shadow-xl">
        <h2 id="modal-transicao-titulo" className="text-base font-semibold text-ink">
          {labelEvento(transicao.evento)}
        </h2>
        {consequencias && <p className="mt-2 text-sm text-grafite">{consequencias}</p>}

        {exigeOverride && (
          <label className="mt-4 block text-sm">
            <span className="text-ink">Aprovador de nível superior</span>
            <input
              type="text"
              value={aprovadorSuperior}
              onChange={(e) => setAprovadorSuperior(e.target.value)}
              className="mt-1 w-full rounded border border-borda bg-base-100 px-3 py-2 text-sm text-ink"
            />
          </label>
        )}

        {transicao.exigeJustificativa && (
          <label className="mt-4 block text-sm">
            <span className="text-ink">Justificativa</span>
            <textarea
              value={justificativa}
              onChange={(e) => setJustificativa(e.target.value)}
              rows={3}
              className="mt-1 w-full rounded border border-borda bg-base-100 px-3 py-2 text-sm text-ink"
            />
          </label>
        )}

        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={onFechar} className="rounded px-3 py-2 text-sm text-grafite hover:bg-borda/40">
            Cancelar
          </button>
          <button
            type="button"
            disabled={!podeConfirmar || carregando}
            onClick={() => onConfirmar(justificativa || undefined, aprovadorSuperior || undefined)}
            className="rounded bg-aco px-4 py-2 text-sm font-medium text-white hover:bg-aco-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {carregando ? 'Aplicando…' : labelEvento(transicao.evento)}
          </button>
        </div>
      </div>
    </div>
  );
}
